var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileCopy = function SvgFileCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "file-copy_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42.3 13.333h-.967v14h14v-.966zm-24.3 0h18.667V32h18.666v28H18zm-4.667 37.334v-42H32V4H8.667v46.667z",
    clipRule: "evenodd"
  })));
};
export { SvgFileCopy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQyLjI5OTggMTMuMzMzM0g0MS4zMzMzVjI3LjMzMzNINTUuMzMzM1YyNi4zNjY4TDQyLjI5OTggMTMuMzMzM1pNMTggMTMuMzMzM0gzNi42NjY3VjMySDU1LjMzMzNWNjBIMThWMTMuMzMzM1pNMTMuMzMzMyA1MC42NjY3VjguNjY2NjdIMzJWNEg4LjY2NjY2VjUwLjY2NjdIMTMuMzMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";